import LocatorPairedComparator from './locatorPaired/LocatorPairedComparator';
import LocatorPairedComparatorFilterConverter from './locatorPaired/LocatorPairedComparatorFilterConverter';
import CalculatedAlertsEqualsComparatorEditor from './calculatedAlerts/CalculatedAlertsEqualsComparatorEditor';
import CalculatedAlertsEqualsComparator from './calculatedAlerts/CalculatedAlertsEqualsComparator';
import CalculatedAlertsEqualsComparatorFilterConverter from './calculatedAlerts/CalculatedAlertsEqualsComparatorFilterConverter';
import SaleLocatorTypeEqualsComparator from './saleLocatorType/SaleLocatorTypeEqualsComparator';
import SaleLocatorTypeEqualsComparatorEditor from './saleLocatorType/SaleLocatorTypeEqualsComparatorEditor';
import SaleLocatorTypeEqualsComparatorFilterConverter from './saleLocatorType/SaleLocatorTypeEqualsComparatorFilterConverter';
import ColorEqualsComparator from './color/ColorEqualsComparator';
import ColorEqualsComparatorEditor from './color/ColorEqualsComparatorEditor';
import ColorEqualsComparatorFilterConverter from './color/ColorEqualsComparatorFilterConverter';
import BusinessStateEqualsComparator from './businessState/BusinessStateEqualsComparator';
import BusinessStateEqualsComparatorEditor from './businessState/BusinessStateEqualsComparatorEditor';
import BusinessStateEqualsComparatorFilterConverter from './businessState/BusinessStateEqualsComparatorFilterConverter';
import ReconciliationStatusEqualsComparator from './reconciliationStatus/ReconciliationStatusEqualsComparator';
import ReconciliationStatusEqualsComparatorEditor from './reconciliationStatus/ReconciliationStatusEqualsComparatorEditor';
import ReconciliationStatusEqualsComparatorFilterConverter from './reconciliationStatus/ReconciliationStatusEqualsComparatorFilterConverter';
import ResetRequestStateEqualsComparator from './resetRequestState/ResetRequestStateEqualsComparator';
import ResetRequestStateEqualsComparatorEditor from './resetRequestState/ResetRequestStateEqualsComparatorEditor';
import ResetRequestStateEqualsFilterConverter from './resetRequestState/ResetRequestStateEqualsFilterConverter';
import CalculatedContractStateEqualsComparator from './calculatedContractState/CalculatedContractStateEqualsComparator';
import CalculatedContractStateEqualsComparatorEditor from './calculatedContractState/CalculatedContractStateEqualsComparatorEditor';
import CalculatedContractStateEqualsComparatorFilterConverter from './calculatedContractState/CalculatedContractStateEqualsComparatorFilterConverter';
import LocatorUnpairedComparator from './locatorPaired/LocatorUnpairedComparator';
import LocatorUnpairedComparatorFilterConverter from './locatorPaired/LocatorUnpairedComparatorFilterConverter';
import RecovrProductsSoldEqualsComparator from './productTypes/RecovrProductsSoldEqualsComparator';
import RecovrProductsSoldEqualsComparatorEditor from './productTypes/RecovrProductsSoldEqualsComparatorEditor';
import RecovrProductsSoldEqualsComparatorFilterConverter from './productTypes/RecovrProductsSoldEqualsComparatorFilterConverter';
export default {
  install(molten) {
    molten.addPlugin('AttributeConditionComparator', CalculatedAlertsEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: CalculatedAlertsEqualsComparator.TYPE,
      editor: CalculatedAlertsEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', CalculatedAlertsEqualsComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', SaleLocatorTypeEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: SaleLocatorTypeEqualsComparator.TYPE,
      editor: SaleLocatorTypeEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', SaleLocatorTypeEqualsComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', LocatorPairedComparator);
    molten.addPlugin('ImagineComparatorFilterConverter', LocatorPairedComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', LocatorUnpairedComparator);
    molten.addPlugin('ImagineComparatorFilterConverter', LocatorUnpairedComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', BusinessStateEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: BusinessStateEqualsComparator.TYPE,
      editor: BusinessStateEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', BusinessStateEqualsComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', ColorEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: ColorEqualsComparator.TYPE,
      editor: ColorEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', ColorEqualsComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', ReconciliationStatusEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: ReconciliationStatusEqualsComparator.TYPE,
      editor: ReconciliationStatusEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', ReconciliationStatusEqualsComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', ResetRequestStateEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: ResetRequestStateEqualsComparator.TYPE,
      editor: ResetRequestStateEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', ResetRequestStateEqualsFilterConverter);
    molten.addPlugin('AttributeConditionComparator', CalculatedContractStateEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: CalculatedContractStateEqualsComparator.TYPE,
      editor: CalculatedContractStateEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', CalculatedContractStateEqualsComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', RecovrProductsSoldEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: RecovrProductsSoldEqualsComparator.TYPE,
      editor: RecovrProductsSoldEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', RecovrProductsSoldEqualsComparatorFilterConverter);
  }
};